import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_NEW_DELIVERY_POINT_ROUTE_RESET = 'POST_NEW_RDELIVERY_POINT_OUTE_RESET';
export const POST_NEW_DELIVERY_POINT_ROUTE_LOADING = 'POST_NEW_DELIVERY_POINT_ROUTE_LOADING';
export const POST_NEW_DELIVERY_POINT_ROUTE_SUCCESS = 'POST_NEW_DELIVERY_POINT_ROUTE_SUCCESS';
export const POST_NEW_DELIVERY_POINT_ROUTE_REJECT = 'POST_NEW_DELIVERY_POINT_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const postNewDeliveryPointRouteReset = () => ({ type: POST_NEW_DELIVERY_POINT_ROUTE_RESET });
export const postNewDeliveryPointRouteLoading = () => ({ type: POST_NEW_DELIVERY_POINT_ROUTE_LOADING });
export const postNewDeliveryPointRouteSuccess = (payload) => ({ type: POST_NEW_DELIVERY_POINT_ROUTE_SUCCESS, payload });
export const postNewDeliveryPointRouteReject = (payload) => ({ type: POST_NEW_DELIVERY_POINT_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postNewDeliveryPointRouteRequest = async (data, idRoute, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/api/Route/AddDeliveryPointsRouteTemplateFile/${idRoute}`, options);
};


